import { AuthActions, LoginActions, LogoutActions } from './AuthorizationConstants';
import handleLoginAction from './Login';
import handleLogoutAction from './Logout';

export function AuthAction(action: AuthActions): Promise<void> {
  switch (action) {
    case 'login':
    case 'login-callback':
    case 'login-failed':
      return handleLoginAction(action as LoginActions);
    case 'logout-callback':
    case 'logged-out':
      return handleLogoutAction(action as LogoutActions);
    default:
      return Promise.resolve();
  }
}
